import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";

import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { MdOutlineNotifications } from "react-icons/md";
import { useLocation } from "react-router-dom";

import { USER_TYPE } from "../constants/common";
import { useNotification } from "../context/NotificationContext";
import { useNavigateWithLang } from "../utils/navigation";
import Button from "./Button";

const NotificationDropdown = () => {
  const { notifications, unreadCount, markNotificationAsRead } = useNotification();

  const navigate = useNavigateWithLang();
  const location = useLocation();

  const goToNotificationsCenter = () => {
    navigate(`/${USER_TYPE.STUDENT.ROLE}/notifications-center`);
  };

  const handleNotificationClick = async (notification) => {
    if (!notification.read_at) {
      await markNotificationAsRead(notification.id);
    }

    if (notification.link) {
      navigate(notification.link);
    } else {
      navigate(
        `/${USER_TYPE.STUDENT.ROLE}/notifications-center`,
        {},
        {
          notificationID: notification.id,
        }
      );
    }
  };

  return (
    <Menu
      menuButton={
        <MenuButton disabled={location.pathname.includes("notifications-center")} className="relative">
          <Button
            className={`${location.pathname.includes("notifications-center") && "bg-blue-600"}`}
            icon={<MdOutlineNotifications className="text-white" size={20} />}
          />
          {unreadCount > 0 && (
            <span className="absolute -right-1 -top-1 rounded-full bg-red-500 px-1 text-xs text-white">
              {unreadCount}
            </span>
          )}
        </MenuButton>
      }
      transition
      align="end"
      menuClassName="max-h-96 w-80 overflow-y-auto rounded-lg bg-white shadow-lg dark:bg-dark-surface"
    >
      <div className="border-b px-4 py-2 text-sm font-semibold text-gray-700 dark:text-white">
        Notifications
      </div>

      {notifications?.length === 0 ? (
        <div className="p-4 text-center text-sm text-gray-500 dark:text-gray-400">No notifications</div>
      ) : (
        notifications.map((n) => (
          <MenuItem
            onClick={() => handleNotificationClick(n)}
            key={n?.id}
            className={`flex items-start gap-3 border-b p-3 text-left transition-colors ${
              !n?.read_at ? "bg-blue-50 dark:bg-blue-900" : "bg-white dark:bg-dark-surface"
            } hover:bg-gray-100 dark:hover:bg-gray-700`}
          >
            <div className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-200 text-center text-xl leading-10 text-white dark:bg-gray-600">
              🔔
            </div>
            <div className="flex-1">
              <div className="text-sm font-medium capitalize text-gray-800 dark:text-white">{n.key}</div>
              <div className="text-xs text-gray-600 dark:text-gray-300">{n.message}</div>
            </div>
            {!n.read_at && <span className="mt-1 h-2 w-2 self-start rounded-full bg-blue-500" />}
          </MenuItem>
        ))
      )}

      <MenuItem
        onClick={goToNotificationsCenter}
        className="cursor-pointer justify-center border-t p-3 text-center text-sm font-semibold text-blue-600 hover:bg-blue-50 dark:text-blue-400 dark:hover:bg-blue-900"
      >
        See All
      </MenuItem>
    </Menu>
  );
};

export default NotificationDropdown;
